<template>
  <div class="text-input">
    <q-input
      ref="input"
      v-model.trim="input"
      :label="label"
      :disable="disable"
      autogrow
      outlined
      stack-label
      @keydown.ctrl.enter.exact="onComment"
    />

    <div class="actions">
      <span v-if="mode === 'update'" class="stakeholder-helper cursor-pointer text-right" @click="$emit('cancel')">
        Cancel
      </span>

      <span
        title="Ctrl + Enter (shortcut)"
        class="stakeholder-helper text-tertiary cursor-pointer text-right"
        @click="onComment"
      >
        {{ btnText }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    disable: Boolean,
    mode: {
      type: String,
      default: 'create'
    }
  },

  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    label() {
      if (this.mode === 'create') return 'Write a comment'
      return 'Update comment'
    },

    btnText() {
      if (this.mode === 'create') return 'Add comment'
      return 'Update comment'
    }
  },

  methods: {
    onComment() {
      if (!this.input || this.disable) return
      this.$emit('comment')
    },

    focus() {
      // access from parent
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-input {
  .actions {
    display grid
    grid-auto-flow column
    justify-content end
    gap 10px
   }
}
</style>
